export const THREAD_LIST_HEIGHT = 530
export const THREAD_HEADER_HEIGHT = 42
